import { VatModelType } from '@teinor/erp/types/company/vat/'
import { useParams } from 'react-router-dom'
import { MediumModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { getDictionaryCountries } from '../../../../../../../utils/reducers/getters'
import { getDictionaryStates } from '../../../../../../../utils/globals/countries'
import useCountryState from '../../../../../../../utils/hooks/useCountry'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { sortCountries } from '../../../../../../../utils/globals/sortCountries'


interface ModalCESingleVatProps extends ModalEditComponentProps { }

const ModalCESingleVat: React.FC<ModalCESingleVatProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { GroupVatId } = useParams()
    const { t } = useTwinTranslation()
    const { country, setCountry } = useCountryState({ defaultCountry: allRowData?.country })
    const fields: FormRender<VatModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    required: true,
                    value: allRowData?.country,
                    onChange: (value: string) => setCountry(value)
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                    required: false,
                    value: allRowData?.state
                },
                {
                    name: 'vat',
                    label: t('vat', 'Impuesto'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    required: true
                },
                {
                    name: 'vat2',
                    label: t('vat2', 'Impuesto secundario'),
                    component: 'InputNumberWithLabelMarginStateFull'
                },
                {
                    name: 'GroupVatId',
                    component: 'InputHidden',
                    value: GroupVatId
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<MediumModalCreateEdit fields={parsedFields} url={'/api/app/config/vat/updateVat'} translations={{
            title: t('editSingleZoneVat', 'Editar zona de impuestos'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} {...rest} />)
    }
    return (<MediumModalCreateEdit fields={fields} url={'/api/app/config/vat/createVat'} translations={{
        title: t('createNewSingleZoneVat', 'Crear nueva zona de impuestos'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCESingleVat